module.exports = "\n        \n\n        input[type='submit']:hover {\n            cursor : pointer;\n        }"


//////////////////
// WEBPACK FOOTER
// ./src/app/locaux/form-locaux/form-locaux.component.css
// module id = ./src/app/locaux/form-locaux/form-locaux.component.css
// module chunks = main